import useEditUser, {
  EditUserProps,
  translatedEditUserProps,
} from 'modules/users/hooks/use-edit-user';
import {UserProps} from 'modules/users/types';
import usersKeys from 'modules/users/util/users-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditUser: React.FC = () => {
  const {getInput} = useFormInputs<EditUserProps>();

  const {id} = useParams();

  return (
    <Edition<EditUserProps, UserProps>
      translationKey={translatedEditUserProps}
      onSubmit={() => useEditUser(id!)}
      border
      detailsUrl={`/users/${id}`}
      queryKey={usersKeys.details(id!)}
      inputs={[
        getInput({
          name: 'name',
        }),
        getInput({
          name: 'cpf',
          mask: 'cpf',
        }),
        getInput({
          name: 'phone',
          mask: 'phone',
        }),
        getInput({
          name: 'email',
        }),
        getInput({
          name: 'password',
        }),
      ]}
    />
  );
};

export default EditUser;
